<app-pharmacy-segment-list-component></app-pharmacy-segment-list-component>